import { StrictMode } from 'react'
import { ApolloProvider } from '@apollo/client'
import { createRoot } from 'react-dom/client'
import gitInfo from '~root/git-info.json'
// Per-weight files include unicode-range for latin + latin-ext; `latin.css` alone does not.
import '@fontsource/lato/100.css'
import '@fontsource/lato/300.css'
import '@fontsource/lato/400.css'
import '@fontsource/lato/700.css'
import '@fontsource/lato/900.css'
import '@fontsource-variable/manrope/wght.css'
import './main.css'
import './locales'
import { apolloClient } from './api'
import App from './App'
import { initSentry } from './sentry'

// Initialize Sentry
initSentry()

const root = document.getElementById('root')

root!.setAttribute('data-commit-hash', gitInfo.commitHash)

document.body.style.overflow = 'clip'

createRoot(root!).render(
  <StrictMode>
    <ApolloProvider client={apolloClient}>
      <App />
    </ApolloProvider>
  </StrictMode>
)
